import { render, staticRenderFns } from "./rwachaxun.vue?vue&type=template&id=ca51428e&scoped=true"
import script from "./rwachaxun.vue?vue&type=script&lang=js"
export * from "./rwachaxun.vue?vue&type=script&lang=js"
import style0 from "./rwachaxun.vue?vue&type=style&index=0&id=ca51428e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca51428e",
  null
  
)

export default component.exports